import axios from "axios";
import ValidateTokenExistence from "../../middlewares/ValidateTokenExistence";

export class BaseJuradosService {
  axiosClient;

  constructor() {
    this.axiosClient = axios.create({
      baseURL: `${process.env.REACT_APP_SERVER_JURA2}`,
    });
    this.initAxiosInterceptor();
  }

  initAxiosInterceptor() {
    this.axiosClient.interceptors.request.use(async (config) => {
      try {
        const token = localStorage.getItem("token");
        await ValidateTokenExistence(config, token)
        return config;
      } catch(e) {
        console.log(e);
      }
    });
  }
}
